import { render, staticRenderFns } from "./HealthRecordDetailsPm.vue?vue&type=template&id=50b7bbea&scoped=true&"
import script from "./HealthRecordDetailsPm.vue?vue&type=script&lang=js&"
export * from "./HealthRecordDetailsPm.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecordDetailsPm.vue?vue&type=style&index=0&id=50b7bbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b7bbea",
  null
  
)

export default component.exports